<template>
  <UserLayout>
    <div
      class="md:px-8 px-4 py-8 md:ml-20 md:mt-16 mt-24 pb-24 flex flex-col justify-center items-center"
    >
      <img
        class="object-cover h-48 rounded-b rounded-t"
        :src="require(`@/assets/img/paymentSuccess.svg`)"
        alt=""
      />
      <div class="flex text-3xl font-bold mt-12">
        <button class="text-green-dark w-8"><CheckCircle /></button>
        <h3 class="ml-4">Payment Successful</h3>
      </div>
      <p class="text-2xl text-gray-dark mt-8">
        {{ creditsPurchased || "XX" }} credits have been added to your wallet.
      </p>
      <button
        class="bg-green-dark text-white rounded-full text-3xl mt-4 py-1 px-4"
        @click="handleClick"
      >
        Back to
        {{ redirectComponentName === "profile" ? "profile" : "checkout" }}
      </button>
    </div>
  </UserLayout>
</template>

<script>
import UserLayout from "@/components/layouts/UserLayout";
import { CheckCircle } from "@/components/icons";
import { mapActions } from "vuex";

export default {
  name: "AddMoneySuccess",
  components: {
    UserLayout,
    CheckCircle,
  },
  data() {
    return {
      redirectUrl: "",
      redirectComponentName: "",
      creditsPurchased: "",
    };
  },
  methods: {
    ...mapActions(["postUserLivestreamAuth"]),

    async handleClick() {
      var batch_id = this.redirectUrl.substring(
        this.redirectUrl.lastIndexOf("/") + 1
      );
      let request = {
        batch_id: batch_id,
        user_type: "guest", // new key added
      };
      await this.postUserLivestreamAuth(request);
      this.$router.push({ path: this.redirectUrl });
    },
  },
  created() {
    const paymentSuccessRedirectProps = localStorage.getItem(
      "paymentSuccessRedirectProps"
    );
    if (paymentSuccessRedirectProps) {
      const { redirectUrl, componentName } = JSON.parse(
        paymentSuccessRedirectProps
      );

      this.redirectUrl = redirectUrl;
      this.redirectComponentName = componentName;
      this.creditsPurchased = this.$route.query.c;
    } else {
      this.$router.push({ path: "/" });
    }
  },
};
</script>